<template>
    <div class="form-group nova-control-wrapper" :class="{'input-group': hasIcon}">
        <!-- <slot name="label">
            <label v-if="label" class="control-label">
                <span v-if="label">{{label}}</span>
                <span v-else-if="name">{{name | setText(label)}}</span>
                <span v-if="lang">({{lang}})</span>
            </label>
        </slot> -->
        <slot name="addonLeft">
            <span v-if="addonLeftIcon" class="input-group-prepend">
                <i :class="addonLeftIcon" class="input-group-text"></i>
            </span>
        </slot>
        <input
                :value="value"
                @input="$emit('input',$event.target.value)"
                v-bind="$attrs"
                class="form-control"
				:class="{'focused': value}"
                aria-describedby="addon-right addon-left">
		<slot name="label">
			<label v-if="label" class="nova-label-control" :title="label">
				<span v-if="label">{{label}}</span>
				<span v-else-if="name">{{name | setText(label)}}</span>
				<span v-if="lang">({{lang}})</span>
			</label>
		</slot>
        <slot></slot>
        <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-append">
        <i :class="addonRightIcon" class="input-group-text"></i>
      </span>
        </slot>
    </div>
</template>
<script>
    export default {
        inheritAttrs: false,
        name: "fg-input",
        props: {
            label: String,
            name: String,
            lang: String,
            value: [String, Number],
            addonRightIcon: String,
            addonLeftIcon: String
        },
		methods:{
			focused(el){
				if(el.value)
					el.classList.add('focused')
				else
					el.classList.remove('focused')
			}	
		},
        computed: {
            hasIcon() {
                const {addonRight, addonLeft} = this.$slots;
                return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
            }
        }
    }
</script>
<style>

</style>
